import React, { useEffect, useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography,
} from '@mui/material';
import iziToast from 'izitoast';

import { updateMembership } from '../../actions/journal';
import { internalServerError } from '../../utils/consts/pathRoutes';
import useIsMobile, { mobileDialogProps } from '../../utils/useIsMobile';
import { studentName } from '../../utils/journalFormat';

/**
 * Правка периода обучения в группе.
 *
 * Дату ставят при добавлении и при переводе, и ошибиться в ней легко — а исправить
 * было нельзя ни в составе группы, ни в карточке слушателя. По этой дате считаются
 * часы, так что неверная дата — это неверная посещаемость.
 *
 * @param membership  строка состава или период из карточки: нужны id, даты и имя
 */
const MembershipPeriodModal = ({ membership, onClose, onSaved }) => {
  const isMobile = useIsMobile();
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!membership) return;
    setDateFrom(membership.date_from || '');
    setDateTo(membership.date_to || '');
  }, [membership]);

  const submit = () => {
    setSaving(true);

    updateMembership(membership.membership_id || membership.id, {
      date_from: dateFrom,
      // Пустое поле — «учится по настоящее время», а не «не менять».
      date_to: dateTo || null,
    })
      .then(() => {
        iziToast.success({ message: 'Период обучения изменён', position: 'topRight' });
        onSaved();
      })
      .catch((e) => iziToast.error({ message: internalServerError(e), position: 'topRight' }))
      .finally(() => setSaving(false));
  };

  return (
    <Dialog open={Boolean(membership)} onClose={onClose} maxWidth="xs" fullWidth {...mobileDialogProps(isMobile)}>
      <DialogTitle>Период обучения</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {membership && (
            <Typography variant="body2" color="text.secondary">
              {studentName(membership)}
              {membership.group_name ? ` · ${membership.group_name}` : ''}
            </Typography>
          )}

          <TextField
            label="В группе с" type="date" value={dateFrom}
            onChange={(event) => setDateFrom(event.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="По" type="date" value={dateTo}
            onChange={(event) => setDateTo(event.target.value)}
            InputLabelProps={{ shrink: true }}
            helperText="Пусто — слушатель продолжает учиться"
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button variant="contained" onClick={submit} disabled={saving || !dateFrom}>
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MembershipPeriodModal;
